import React, { useEffect, useRef } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import { loadFlights, setFlightDate, setAirline } from "../../store/flights";
import {formatFlightDate, formatDate, getFlightDuration, getFlightStatus, isFlightOpen, formatPax, formatFlightHtml} from './flightFunctions'
import { TimelineChart } from './timeline/main';
import FlightModal from './flightModal';
import Filters from './filters';
import styles from './styles';

const formatTimelineDate = (flightDate) => {
  let dateArr = flightDate.split('-')
  dateArr[0] = Number(dateArr[0])
  dateArr[1] = Number(dateArr[1]) - 1
  dateArr[2] = Number(dateArr[2])
  return new Date(dateArr[0], dateArr[1], dateArr[2], 0, 0)
}

const setVerticalAxisProp = (airline) => {
  return airline === 'ZW'?'FlightNumber':'TailNumber'
}

function Flights(props) {
  const dispatch = useDispatch()
  const { airline, statusFilter, originFilter, destinationFilter, regionFilter } = props
  const flights = useSelector(state => state.entities.flights.list)
  const flightDate = useSelector(state => state.entities.flights.flightDate)
  const timelineDate = formatTimelineDate(flightDate)
  const loading = useSelector(state => state.entities.flights.loading)
  const editReqStatus = useSelector(state => state.entities.flights.editReqStatus)
  const ref = useRef(0)

  useEffect(() => {
    dispatch(setAirline(airline))
    dispatch(loadFlights(formatFlightDate(flightDate)));
  }, [flightDate]);

  const changeFlightDate = (event) => {
    dispatch(setFlightDate(event.target.value))
  }

    // Determine if it's a mobile view or desktop view based on screen width
    const isMobileView = window.innerWidth < 768; // Set the mobile breakpoint as 768 pixels

  // NOTE // gets the beginning OR end date for the timeline
  const getTimelineTimes = (flights, isStart) => {
    let flightTimes = _.cloneDeep(flights)
    // NOTE // getting the times for comparison, then sort them
    flightTimes = isStart ? flights.map(flt => formatDate(flightDate, flt, 'localDep').getTime()).sort() : flights.map(flt => formatDate(flightDate, flt, 'localArr').getTime()).sort()
    // NOTE // get the first or last flight-time depending on isStart
    let time = flightTimes[isStart ? 0 : flightTimes.length - 1]

    time = new Date(time).getHours()
    return time
  }

  // NOTE // filtering flights before handing them off to Timeline
  const filterFlights = (flights) => {
    let flightsCopy = _.cloneDeep(flights)
    let filteredFlights = []
    let filters = [{property: 'Origin', list: originFilter}, {property: 'Destination', list: destinationFilter}, {property: 'Status', list: statusFilter}, {property: 'Region', list: regionFilter}]
    // NOTE // loop over flights
    for (let i = 0; i < flightsCopy.length; i++) {
      const flight = flightsCopy[i];
      let flightStatus = getFlightStatus(flight, true)
      // NOTE // loop over each filter
      for (let j = 0; j < filters.length; j++) {
        const filter = filters[j];
        let property = filter.property
        // NOTE // if there is anything selected for this filter
        if (filter.list.length) {
          // NOTE // true if the flight has the filter value
          let keep = filter.property !== 'Status' ? filter.list.includes(flight[property]) : filter.list.includes(flightStatus)
          if (!keep) {
            // NOTE // filteredFlights is what we are NOT using
            filteredFlights.push(flight.fltid)
          }
        }
      }
    }

    return flightsCopy.filter(f => !filteredFlights.includes(f.fltid))
  }

  // NOTE // configuring chart-width so that all flights show all their info (just so happens to be 100px exactly)
  const configureChartWidth = () => {
    let flightsCopy = _.cloneDeep(flights)
    let timelineStart = getTimelineTimes(flightsCopy, true)
    let timelineEnd = getTimelineTimes(flightsCopy, false)
    // NOTE // flight labels take up 1/12 of the total chart width, while the rows take up the other 11/12
    // NOTE // the amount of hours from the first flight to the last (the +2 is to include the 1st and last hour)
    let chartTime = timelineEnd - timelineStart + 2
    // NOTE // get the shortest flight duration in hours
    let shortestFlt = 100
    for (let i = 0; i < flightsCopy.length; i++) {
      const flt = flightsCopy[i];
      let fltDep = flt.ETD ? flt.ETD.slice(12) : flt.Departure
      let fltArr = flt.ETA ? flt.ETA.slice(12) : flt.Arrival
      let fltDuration = getFlightDuration(fltDep, fltArr)
      // NOTE // replaces shortestFlt if the fltDuration is lower or if shortestFlt isn't set
      shortestFlt = fltDuration < shortestFlt ? fltDuration : shortestFlt
    }
    console.log(shortestFlt)
    // NOTE // 100/shortestFlt gives the length an hour needs to be to show all flt info, Math.floor(nums) + 1 because you can't see a 10th of a pixel
    let hourWidth = Math.abs((Math.floor(110/shortestFlt) + 1) * (12/11))
    console.log('hourWidth', hourWidth)
    console.log('return ', ((chartTime * hourWidth) + 1))
    return Math.floor(chartTime * hourWidth) + 1
  }

  const formatFlightLabel = (flight) => {
    // NOTE // formatDate returns a date-object, the substring part returns 'HH:MM' formatting
    let departure = formatDate(flightDate, flight, 'dep').toString().substring(16, 21)
    let arrival = formatDate(flightDate, flight, 'arr').toString().substring(16, 21)
    let userDepartTime = formatDate(flightDate, flight, 'localDep').toString().substring(16, 21)
    let userArriveTime = formatDate(flightDate, flight, 'localArr').toString().substring(16, 21)
    let flightColor = isFlightOpen(flight) ? 'white' : 'black'
    // NOTE // if any of these are present (SA, MM, PN) it will make an array out of it
    let hasStandbyPax = flight.PaxList.match(/\- (SA|MM|PN)/g)
    console.log("flight.PaxList",flight.PaxList);
    console.log("hasStandbyPax",hasStandbyPax);

    let flightLabelArr = [
      {
        text: [`${flight.FlightNumber}  `, ` `],
        styles: [
          {fontWeight: 'bold', marginRight: '3px'},
          // NOTE // this is the open/closed indicator
          {fontWeight: 'bold', border: '1px solid black', borderRadius: '85px', height: '8px', width: '8px', marginTop: '4px', backgroundColor: flightColor},
          {height: '15px'}
        ]
      },
      {
        text: [`${flight.Load}`,`${hasStandbyPax ? `STBY` : ''}`, `${hasStandbyPax ?  `(${hasStandbyPax.length})` : ''}`],
        styles: [{}, {fontWeight: 'bold', marginLeft: '3px', marginRight: '3px', color: '#bb0000'}, {}]
      },
      {text: [`${flight.Origin} ${departure} (${userDepartTime})`], styles: [{}]},
      {text: [`${flight.Destination} ${arrival} (${userArriveTime})`], styles: [{}]}
    ]

    return flightLabelArr
  }

  // NOTE // formatting flight times for Timeline
  const formatTimlineFlights = (flights) => {
    let formattedFlights = []
    // TODO // filter flights here
    let flightsCopy = _.cloneDeep(flights)
    let filteredFlights = filterFlights(flightsCopy)

    for (let i = 0; i < filteredFlights.length; i++) {
      let flight = filteredFlights[i];
      // NOTE // if the flight has an ETD/ETA, it means the flight has been moved and the ETD/ETA should be shown in the chart
      if (flight.ETA && flight.ETD) {
        // NOTE // originalDeparture/originalArrival are the airports original scheduled time
        flight.originalDeparture = flight.Departure
        flight.originalArrival = flight.Arrival
        // NOTE // Departure/Arrival are the current local (not airport) times
        flight.Departure = flight.ETD.slice(12)
        flight.Arrival = flight.ETA.slice(12)
        // NOTE // airportDepTime/airportArrTime are the current airport times
        flight.airportDepTime = flight.Departure
        flight.airportArrTime = flight.Arrival
      }
      else {
        flight.originalDeparture = flight.Departure
        flight.originalArrival = flight.Arrival
        flight.airportDepTime = flight.Departure
        flight.airportArrTime = flight.Arrival
      }
      flight.label = formatFlightLabel(flight)
      flight.hoverHtml = formatFlightHtml(flight, flightDate)
      flight.Departure = formatDate(flightDate, flight, 'localDep')
      flight.Arrival = formatDate(flightDate, flight, 'localArr')
      flight.PaxList = formatPax(flight.PaxList ? flight.PaxList.split(';') : [])
      flight.key = flight.fltid
      formattedFlights.push(flight)
    }

    return formattedFlights
  }

  return (
    <Grid container>
      {/* <Filters filters={filterProps} flights={flights} classes={classes} isMobile={isMobile} /> */}
      <Grid container ref={ref}>
          {
            flights && flights.length && ref.current.offsetWidth && !loading ?
            // <div id="chartWrapper" style={{ overflowX: 'scroll', overflowY: 'visible', width: (ref.current.offsetWidth + 'px')}}>
             <div id="chartWrapper" className='flightTimelineScroll' style={{ overflowX: 'auto', overflowY: 'auto', width: '100%'}}> 
              <TimelineChart
                items={formatTimlineFlights(flights)}
                timelineDate={timelineDate}
                timelineStart={getTimelineTimes(flights, true)}
                timelineEnd={getTimelineTimes(flights, false)}
                dateItemsLoc={['Departure', 'Arrival']}
                vAxisProp={setVerticalAxisProp(airline)}
                chartHeight={900}
                chartWidth={configureChartWidth(flights)}
                // chartWidthRef={ref.current.offsetWidth}
                showCurTime={flightDate === new Date().toISOString().slice(0, 10)}
                itemOptions={
                  {
                    defaultColor: '#9fc5e9',
                    colorIf: getFlightStatus,
                    hover: 'hoverHtml',
                    itemStyle:isMobileView ? {height: '64px', top: '25%', fontFamily: 'Helvetica',width:'140px'} : {height: '64px', top: '25%', fontFamily: 'Helvetica'}
                  }
                }
                labelOptions={
                  {
                    label: 'label'
                  }
                }
                itemModal={
                  {
                    component: <FlightModal flightDate={flightDate} editStatus={editReqStatus}/>
                  }
                }
              />
            </div>
             :
            <Grid container justify='center' alignContent='center' item xs={12} style={{height: '200px'}}>
              <h2>
                {loading ? 'loading...' : 'There are no flights for this date'}
              </h2>
            </Grid>
          }
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(Flights)